// pages/Dashboard/useChatbotStats.js
import { useState, useEffect } from "react";
import axios from "axios";
import backendURL from "../../config";
import { useChatbots } from "../../contexts/ChatbotContext"; // Import the context hook

export default function useChatbotStats() {
    const { activeChatbot } = useChatbots(); // Get the active chatbot
    const [stats, setStats] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Do nothing if there's no active chatbot selected yet
        if (!activeChatbot) {
            setStats(null);
            setLoading(false);
            return;
        }

        const fetchStats = async () => {
            setLoading(true);
            setError(null);
            try {
                const token = localStorage.getItem('access_token');
                const headers = { Authorization: `Bearer ${token}` };
                
                // FIX: Pass the active chatbot's ID as a query parameter
                const params = { chatbot_id: activeChatbot.id };
                
                const response = await axios.get(`${backendURL}/get-retrain-summary`, { headers, params });
                const responseData = response.data.data; // The data is now a direct object

                if (Object.keys(responseData).length > 0) {
                    const privateDocsData = responseData.private_documents || {};
                    const websiteLinksData = responseData.website_links || {};
                    const siteMapsData = responseData.site_maps || {};
                    const tokensData = responseData.tokens || {};
    
                    setStats({
                        privateDocs: {
                            total_documents: privateDocsData.total_documents || 0,
                            total_page_characters: privateDocsData.total_page_characters || 0,
                            total_page_words: privateDocsData.total_page_words || 0,
                            total_tokens: privateDocsData.total_tokens || 0,
                        },
                        websiteLinks: {
                            total_links: websiteLinksData.total_links || 0,
                            total_page_characters: websiteLinksData.total_page_characters || 0,
                            total_page_words: websiteLinksData.total_page_words || 0,
                            total_tokens: websiteLinksData.total_tokens || 0,
                        },
                        siteMaps: {
                            total_sitemaps: siteMapsData.total_sitemaps || 0,
                        },
                        tokens: {
                            total_input_tokens: tokensData.total_input_tokens || 0,
                            total_output_tokens: tokensData.total_output_tokens || 0,
                            total_total_token: tokensData.total_total_token || 0,
                        },
                        totalCharacters: (privateDocsData.total_page_characters || 0) +
                                         (websiteLinksData.total_page_characters || 0),
                        totalWords: (privateDocsData.total_page_words || 0) +
                                    (websiteLinksData.total_page_words || 0),
                        totalTokens: (privateDocsData.total_tokens || 0) +
                                     (websiteLinksData.total_tokens || 0),
                    });
                }
            } catch (err) {
                if (err.response && err.response.status === 401) {
                    setError("Authentication error. Please log in again.");
                } else {
                    setError("Failed to fetch stats for the selected chatbot.");
                }
            } finally {
                setLoading(false);
            }
        };

        fetchStats();
    }, [activeChatbot]); // Re-run the effect whenever the activeChatbot changes

    return { stats, error, loading };
}